import { createApi } from '@reduxjs/toolkit/query/react'
import { GET_CMS_PAGE_CONTENT } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const cmsApi = createApi({
    reducerPath: 'cmsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/cms",
    }),
    tagTypes: ["CmsPageDetail"],
    endpoints: (builder) => ({

        // get cms page
        getCmsPage: builder.query({
            query: (search) => ({
                method: "GET",
                url: `${GET_CMS_PAGE_CONTENT}/${search}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["CmsPageDetail"]
        }),
    }),
})

export const { useGetCmsPageQuery } = cmsApi;